import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {DataTableStateEvent} from "primereact/datatable";

export const usePagination = () => {
    const [limitData, setLimitData] = useState<number>(10);
    const [page, setPage] = useState<number>(1);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const pageParams = searchParams.get('page');

        if (pageParams) {
            const pageNum = parseInt(pageParams, 10);
            setPage(pageNum);
        } else {
            setSearchParams({ page: '1' }, { replace: true });
            setPage(1);
        }
    }, [searchParams, setSearchParams]);

    const handlePageChange = (e: DataTableStateEvent) => {
        setLimitData(e.rows);
        const pages = e.first / e.rows + 1;
        setPage(pages);
        setSearchParams({ page: pages.toString() });
    };


    return {
        page, limitData, handlePageChange
    }
}